module.exports = __webpack_public_path__ + "static/img/burguer-color.b363b37.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/burguer-color.gif
// module id = GSoC
// module chunks = 4